import { refreshIdentity } from "@/utils/identity";
import axios, { isAxiosError } from "axios";

/*
 * A 401 means the session is gone. Refreshing identity is enough: AppRouter
 * sees the user is logged out and sends them to login.
 */
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (isAxiosError(error) && error.response?.status === 401) {
            void refreshIdentity();
        }

        return Promise.reject(error);
    },
);
